module.exports = __webpack_public_path__ + "img/loading.d36c0042.gif";